__turbopack_context__.v({
  "header_wrapper": "index-module-scss-module__ZtYM5W__header_wrapper",
});
